export const ActionTypes = {
  FILTER_ROUTES_INPUTS: "FILTER_ROUTES_INPUTS",
  REQUEST_DATA: "REQUEST_DATA",
  FILTER_ROUTES: "FILTER_ROUTES",
  GET_DATA: "GET_DATA",
  GET_SETTLEMENT_DISPENSERS: "GET_SETTLEMENT_DISPENSERS",
  GET_SETTLEMENT_PRODUCTS: "GET_SETTLEMENT_PRODUCTS",
  GET_SETTLEMENT_PAYMENTS: "GET_SETTLEMENT_PAYMENTS",
  GET_SETTLEMENT_ACCOUNT_DETAILS: "GET_SETTLEMENT_ACCOUNT_DETAILS",
  SET_ERROR: "SET_ERROR",
  CHANGE_STATION_ROUTES: "CHANGE_STATION_ROUTES",
  CHANGE_UNIT_TYPE: "CHANGE_UNIT_TYPE",
  CHANGE_START_DATE: "CHANGE_START_DATE",
  CHANGE_END_DATE: "CHANGE_END_DATE",
  CLEAR_ERROR: "CLEAR_ERROR",
  SET_ROUTE: "SET_ROUTE",
  SET_CONFIG_PAGE: "SET_CONFIG_PAGE",
  SET_CONFIG_PAGE_SIZE: "SET_CONFIG_PAGE_SIZE",
  SET_CONFIG_FILTER: "SET_CONFIG_FILTER",
  SET_CONFIG_SORTED: "SET_CONFIG_SORTED",
  REQUEST_ENDOWMENTS: "REQUEST_ENDOWMENTS",
  SET_ENDOWMENTS: "SET_ENDOWMENTS",
  EDIT_ENDOWMENT: "EDIT_ENDOWMENT",
  REQUEST_ENDOWMENT: "REQUEST_ENDOWMENT",
  GET_ENDOWMENT: "GET_ENDOWMENT",
  REQUEST_SETTLEMENT: "REQUEST_SETTLEMENT",
  SET_SETTLEMENT: "SET_SETTLEMENT",
  RESET_SETTLEMENT: "RESET_SETTLEMENT",
  EDIT_SETTLEMENT: "EDIT_SETTLEMENT",
  SELECT_NOTE: "SELECT_NOTE",
  DESELECT_NOTE: "DESELECT_NOTE",
  REQUEST_SETTLEMENT_NOTE: "REQUEST_SETTLEMENT_NOTE",
  EDIT_SETTLEMENT_NOTE: "EDIT_SETTLEMENT_NOTE",
  EDIT_NEW_SETTLEMENT_NOTE: "EDIT_NEW_SETTLEMENT_NOTE",
  SET_NOTES_MODAL: "SET_NOTES_MODAL",
  REMOVE_SETTLEMENT_NOTE: "REMOVE_SETTLEMENT_NOTE",
  REQUEST_CUSTOMER: "REQUEST_CUSTOMER",
  SET_CUSTOMER_ROUTE: "SET_CUSTOMER_ROUTE",
  SET_ROUTES_SNACKBAR: "SET_ROUTES_SNACKBAR",
  RESET_ROUTES_SNACKBAR: "RESET_ROUTES_SNACKBAR",
  SET_ROUTES_INPUTS: "SET_ROUTES_INPUTS",
  SET_TICKET_TO_PRINT: "SET_TICKET_TO_PRINT",
  SET_UNIT_INFORMATION: "SET_UNIT_INFORMATION",
  CHANGE_SETTLEMENT_DISPENSER: "CHANGE_SETTLEMENT_DISPENSER",
  CHANGE_SETTLEMENT_START_ROUTE_ENDOWMENTS:
    "CHANGE_SETTLEMENT_START_ROUTE_ENDOWMENTS",
  CHANGE_SETTLEMENT_END_ROUTE_ENDOWMENTS:
    "CHANGE_SETTLEMENT_END_ROUTE_ENDOWMENTS",
  CHANGE_SETTLEMENT_LTS: "CHANGE_SETTLEMENT_LTS",
  CHANGE_SETTLEMENT_PERCENTAGE: "CHANGE_SETTLEMENT_PERCENTAGE",
  SET_KG_BULK_VALUE: "SET_KG_BULK_VALUE",
  SET_SETTLEMENT_NEW_NOTE: "SET_SETTLEMENT_NEW_NOTE",
  SELECT_SETTLEMENT_NEW_NOTE_DETAIL: "SELECT_SETTLEMENT_NEW_NOTE_DETAIL",
  EDIT_SETTLEMENT_NEW_NOTE_DETAIL: "EDIT_SETTLEMENT_NEW_NOTE_DETAIL",
  DELETE_SETTLEMENT_NEW_NOTE_DETAIL: "DELETE_SETTLEMENT_NEW_NOTE_DETAIL",
  SET_SETTLEMENT_NEW_NOTE_DETAIL: "SET_SETTLEMENT_NEW_NOTE_DETAIL",
  ADD_SETTLEMENT_NEW_NOTE: "ADD_SETTLEMENT_NEW_NOTE",
  CLEAN_ROUTES_BY_TYPE: "CLEAN_ROUTES_BY_TYPE",
  SETTLEMENT_TOTAL_REPORT: "SETTLEMENT_TOTAL_REPORT",
  SET_PIN: "SET_PIN",
  SET_AUTO_MODE: "SET_AUTO_MODE",
  SET_CAUSES: "SET_CAUSES",
  SET_DEL_CAUSE: "SET_DEL_CAUSE",
  IS_NEW_NOTE: "IS_NEW_NOTE",
  REMOVE_ALL_NOTES: "REMOVE_ALL_NOTES",
  REMOVE_ROUTE_SHARE: "REMOVE_ROUTE_SHARE",
  UPDATE_NOTE_ACC: "UPDATE_NOTE_ACC",
  ASSIGN_SGC: "ASSIGN_SGC",
  UPDATE_NOTE_FOLIO: "UPDATE_NOTE_FOLIO",
  SET_TRANSFER_INVOICE_TOKEN: "SET_TRANSFER_INVOICE_TOKEN",
};
